import React from 'react';

import Loader from 'components/Loader';
import { insights as TEXT } from 'locales/en';
import { CURRENCY_SYMBOL } from 'utils/transform';
import { priceFromAPI } from 'utils/price';

const TotalRaised = ({ isLoading, data }) => {
  return (
    <div className="card h-14 lg:h-24 rounded flex items-center relative">
      {isLoading ? (
        <Loader
          isBarVisible={false}
          fullScreen={false}
          className="justify-center items-center -mt-14"
        />
      ) : (
        <p className="text-xl">
          {TEXT.totalRaised}
          <strong>
            {CURRENCY_SYMBOL.EUR}
            {priceFromAPI(data)}
          </strong>
        </p>
      )}
    </div>
  );
};

export default TotalRaised;
